import React, { useEffect } from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import Form from '../components/Form/Form';
import UiInputText from '../components/Form/UiInputText';
import UiInputTextarea from '../components/Form/UiInputTextarea';
import UiInputList from '../components/Form/UiInputList';
import WindowBody from '../components/Window/WindowBody';
import WindowFooter from '../components/Window/WindowFooter';
import { UiButton } from '../components/UiButton';

const statusList = [
    { id: 'online', title: 'Online' },
    { id: 'offline', title: 'Offline' },
    { id: 'alerta', title: 'Alerta' },
];

export default function UsinaForm(props: any) {
    const methods = useForm({
        defaultValues: props.data,
    });
    const { handleSubmit, reset } = methods;

    useEffect(() => {
        if (props.data) {
            reset(props.data);
        }
    }, [props.data, reset]);

    return (
        <FormProvider {...methods}>
            <Form onSubmit={handleSubmit(props.triggerSubmit)} methods={methods}>
                <WindowBody>
                    <div className="row">
                        <UiInputText size={4} name="solarmanId" label="SolarMan ID" disabled />
                        <UiInputText size={8} name="nome" label="Nome" />
                        <UiInputText size={4} name="capacidade" label="Capacidade (kWp)" type="number" step="0.01" min="0" />
                        <UiInputList size={4} name="status" label="Status" list={statusList} idField="id" titleField="title" />
                        <UiInputTextarea size={12} name="endereco" label="Endereço" rows={2} />
                    </div>
                    <p className="text-muted small mb-0">
                        Nome, capacidade e status são sobrescritos na próxima sincronização com o provedor de monitoramento.
                    </p>
                </WindowBody>

                <WindowFooter>
                    <UiButton variant="secondary" onClick={props.triggerClose}>Fechar</UiButton>
                    <UiButton variant="primary" type="submit">Salvar</UiButton>
                </WindowFooter>
            </Form>
        </FormProvider>
    );
}
